var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "about-content" }, [
      _c("h1", { staticClass: "title" }, [_vm._v("\n    About us\n  ")]),
      _vm._v(" "),
      _c("div", { staticClass: "content" }, [
        _c("h3", [
          _vm._v(
            "\n      We built LMK to help you build new and meaningful friendships.\n    "
          ),
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "Friends bring more happiness into our lives than virtually anything else. It inspires purpose, encourages laughter, and brings joy. LMK is a social network that makes it fun, easy, and safe to build those important connections. "
          ),
        ]),
        _vm._v(" "),
        _c("h3", [
          _vm._v("\n      LMK is made in the heart of Silicon Valley.\n    "),
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "We’re a nimble team of thinkers, designers, engineers, and doers based a couple miles from Stanford University in Palo Alto, California. We’re fortunate to be backed by leading venture capitalists who have brought you some of your favorite social companies such as Airbnb, Lyft, Zoom, Slack, and TikTok. We’re always looking for bright and creative individuals to join us at LMK. Check our career opportunities to find out more!"
          ),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// src/components/common/Aboutus.vue